import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WatchFunnelService } from '../../../../services/watch-funnel.service';
import { WatchAccountService } from '../../../../services/watch-account.service';
import { IFunnel } from '../../../../interfaces/graph-types';
import { AccountService } from '../../../../services/account.service';
import { FunnelService } from '../../../../services/funnel.service';
import { Subject, Subscription } from 'rxjs';
import { UtilityService } from '../../../../services/utility.service';

@Component({
  selector: '[account-funnel-layout]',
  template: require('./account-funnel-layout.component.pug'),
  styles: [require('./account-funnel-layout.component.css').toString()],
})
export class AccountFunnelLayoutComponent {
  funnel: IFunnel;
  routesub: any = null;
  accsub: any = null;
  campsub: any = null;
  missionControlSubject: Subject<boolean> = new Subject<boolean>();
  timeZoneCaching: Subscription;

  // -------------------------------------------------------------------
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private watch_funnel: WatchFunnelService,
    private watch_account: WatchAccountService,
    private accountService: AccountService,
    private funnelService: FunnelService,
    private utilityService: UtilityService,
  ) {
    this.timeZoneCaching = this.utilityService
      .getTimeZones()
      .subscribe(res => {});
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.routesub = this.route.paramMap.subscribe(params => {
      let funnel_id = params.get('funnel_id');

      this.watch_funnel.funnelId().next(funnel_id);

      this.campsub = this.accountService.funnel(funnel_id).subscribe(funnel => {
        this.funnel = funnel;
      });
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.timeZoneCaching) {
      this.timeZoneCaching.unsubscribe();
    }
    if (this.routesub) {
      this.routesub.unsubscribe();
    }
    if (this.accsub) {
      this.accsub.unsubscribe();
    }
    if (this.campsub) {
      this.campsub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  trackByFn(index, item) {
    // https://medium.freecodecamp.org/best-practices-for-a-clean-and-performant-angular-application-288e7b39eb6f
    return item.id; // unique id corresponding to the item
  }

  // -------------------------------------------------------------------
  navigateToParents() {
    this.router.navigate([
      '/account/' + this.watch_account.accountId().getValue() + '/funnels/',
    ]);
  }

  bottomHeight = '-100%';
  sliderOpened = false;

  // -------------------------------------------------------------------
  openMissionControl() {
    console.warn('hop');
    this.missionControlSubject.next(true);
  }
}
